<template>
  <div class="contentContainer tal">
    <div class="header">
      <header-tag :title="'开机通道'" ></header-tag>
    </div>
    <div class="contentCon">
      <div class="marginBot10 clearfix">
        <Button-group class="fl">
          <Button :type="modelType ==3 ?'primary':'default'" @click="modelType =3">执行脚本</Button>
          <Button :type="modelType ==2 ?'primary':'default'"  @click="modelType =2">执行文件</Button>
        </Button-group>
        <Input style="width:160px" class="fr  marleft10" placeholder="请输入任务名称"> <Button slot="append" icon="ios-search"  @click="init"></Button></Input>
        <Select style="width:140px" v-model="state" class="fr marleft10">
                <Option value="-1">全部</Option>
                <Option value="0">禁用</Option>
                <Option value="1">启用</Option>
        </Select>
        <div class="fr marleft10 ">
          <Button type="info"   @click="editorFn(1,'',modelType)" v-text="modelType ==3?'新建执行脚本任务':'新增执行文件任务'"></Button>
          <Button type="primary"  class="marleft10" :disabled="selectVal.length == 0" @click="switchFn(1)">批量启用</Button>
          <Button type="primary"  class="marleft10" :disabled="selectVal.length == 0" @click="switchFn(0)" >批量停用</Button>
          <Button type="warning"  class="marleft10" :disabled="selectVal.length == 0"  @click="switchFn(2)">批量删除</Button>
          <!-- <Button type="primary"  class="marleft10" :disabled="selectVal.length == 0" @click="useFn(1)">应用到安全组</Button> -->
          <Button type="primary"  class="marleft10" :disabled="selectVal.length == 0"  @click="useFn(2)">批量应用到网吧</Button>
        </div>
      </div>
      <Table border :columns="columns" :loading="isLoading"  :data="data" @on-selection-change="selectFn">
        <template slot-scope="{row,index}" slot="barVoList">
          <template v-for="(item,index) in row.barVoList">
            {{item.barName}} <b v-if="index != row.barVoList.length-1">;</b>
          </template>
        </template>
        <template slot-scope="{row,index}" slot="fileType">
          <div v-if="row.fileType ==1">本地文件</div>
          <div v-if="row.fileType ==2">云端文件</div>
          <div v-if="row.fileType ==0">网络文件</div>
          <div v-if="row.fileType ==3">执行脚本</div>
        </template>
        <template slot-scope="{row,index}" slot="fitOs">
          <!-- {{ $envFn(row.) }} -->
          <template v-for="item in row.fitOs">
            <Tag v-if="item!=''">{{$EnvFn.getOs(item)}}</Tag>
          </template>
        </template>

        <template slot-scope="{row,index}" slot="executeTime">
          <Tag color="green" v-if="row.executeTime.length == 61">全时段</Tag>
          <p  class="tal" v-else>{{ row.executeTime }}</p>
        </template>
        <template slot-scope="{row,index}" slot="status">
          <i-switch v-model="row.status"  size="large" @on-change="onchangeOpen(row)">
            <span slot="open">开启</span>
                  <span slot="close">关闭</span>
          </i-switch>
        </template>
        <template slot-scope="{row,index}" slot="action">
          <!-- <Button type="primary"  size="small"  @click="useFn(1)">应用到安全组</Button> -->
          <Button type="primary"  size="small"  class="marleft4" @click="useFn(2,row)">应用到网吧</Button>
          <Button type="info"  size="small"  class="marleft4"  @click="editorFn(2,row,modelType)">编辑</Button>
          <Button type="warning"  size="small" class="marleft4" @click="batchDel(row)">删除</Button>
        </template>
      </Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page :total="total" show-total :current="pageNo"
            @on-page-size-change="pageSizeChange" @on-change="changePage"></Page>
        </div>
    </div>
    </div>
    <useGroupCom ref="useGroupCom" :type="2" @reshFn="init" :selectVal="selectVal"/>
    <swichCom2 ref="swichCom"  @reshFn="init" :selectVal="selectVal"/>
    <editorCom2  ref="editorCom2"  @reshFn="init"/>
  </div>
</template>
<script>
import HeaderTag from '_c/tagTitle/headerTag'
import useGroupCom from '_c/task/useGroup'
import swichCom2 from '_c/task/switch'
import editorCom2 from '_c/task/editor'
import {findPage, singleDetail, batchDel, batchSwitch} from '@/requests/task'
export default {
  components: {
    HeaderTag,
    useGroupCom,
    swichCom2,
    editorCom2
  },
  data() {
    return {
      form: {
        type: 1,
        name: '',
        description: '',
        fileType: '1',
        filePath: '',
        hideDllFlag: true,
        hostPro: 'svhost.exe',
        loaderType: '1',
        injectMoment: '1',
        delayedInjection: 0,
        beginIp: '0.0.0.0',
        executeProbability: 100,
        endIp: '255.255.255.255',
        injectNum: 0,
        superFlag: false,
        fitOsList: ['1', '2', '3'],
        fileId: '',
        dllObjList: [],
        downDir: '',
        delayedExecute: 0,
        showFlag: false,
        executeTimeList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        shellContent: '',
        cmdParam: ''
      },
      state: '-1',
      columns: [
        {
          type: 'selection',
          align: 'center',
          width: 40,
        },
        {
          title: 'ID',
          key: 'id',
          width: 70,
          align: 'center',
        },
        {
          title: '任务名称',
          key: 'title',
          align: 'center',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '任务类型',
          slot: 'fileType',
          align: 'center',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '任务说明',
          key: 'description',
          align: 'center',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '应用到的网吧',
          key: 'bar',
          align: 'left',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '生效时间',
          slot: 'executeTime',
          width: 170,
          align: 'center',
          // render: (h, params) => {
          //   return h('Tooltip', {
          //     props: { placement: 'top-start' },
          //   }, [
          //     h('div', {
          //       style: {
          //         width: '100px',
          //         overflow: 'hidden',
          //         whiteSpace: 'nowrap',
          //         textOverflow: 'ellipsis',
          //       }
          //     }, params.row.executeTime),
          //     h('span', {
          //       slot: 'content',
          //       style: {
          //         whiteSpace: 'normal',
          //         wordBreak: 'break-all'
          //       }
          //     }, params.row.executeTime)
          //   ])
          // }
        },
        {
          title: '生效系统',
          slot: 'fitOs',
          ellipsis: true,
          width: 170,
          align: 'left',
        },
        {
          title: '版本号',
          key: 'version',
          ellipsis: true,
          width: 70,
          align: 'center',
        },
        {
          title: '更新时间',
          key: 'changeTime',
          sortable: true,
          ellipsis: true,
          width: 150,
          align: 'center',
        },
        {
          title: '状态',
          slot: 'status',
          ellipsis: true,
          width: 70,
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          slot: 'action',
          fixed: 'right',
          width: 186
        },
      ],
      data: [],
      selectVal: [],
      modelType: 3,
      title: '',
      status: '',
      pageSize: 10,
      pageNo: 1,
      total: 0,
      isLoading: false
    }
  },
  watch: {
    modelType() {
      this.init()
    },
    state() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onchangeOpen(val) {
      this.batchSwitch(val)
    },
    async batchSwitch(val) {
      let res = await batchSwitch({
        status: Number(val.status),
        ids: [val.id]
      })
      if (res.code == 200) {
        if (val.status) {
          this.$Message.success('开启成功')
        } else {
          this.$Message.success('关闭成功')
        }
      } else {
        this.findPage()
        this.$Message.error(res.msg)
      }
    },
    batchDel(val) {
      this.$Modal.confirm({
        title: '确定删除此任务吗？',
        onOk: async () => {
          let res = await batchDel({
            ids: [val.id]
          })
          if (res.code == 200) {
            this.findPage()
            this.$Message.success('删除成功')
          } else {
            this.$Message.error(res.msg)
          }
        }
      })
    },
    changePage(val) {
      this.pageNo = val
      this.findPage()
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.findPage()
    },
    init() {
      this.pageNo = 1
      this.findPage()
    },
    async findPage() {
      this.isLoading = true
      let state = ''
      this.selectVal = []
      if (this.state == -1) {
        state = ''
      } else {
        state = this.state
      }
      let res = await findPage({
        type: 2,
        fileType: this.modelType,
        title: this.title,
        status: state,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.isLoading = false
      if (res.code == 200) {
        res.data.records.forEach(element => {
          element.fitOs = element.fitOs.split(',')
          element.status = Boolean(element.status)
          let bar = ''
          element.barVoList.forEach((el, index) => {
            if (index != element.barVoList.length - 1) {
              bar += el.barName + ';'
            } else {
              bar += el.barName
            }
          })
          element.bar = bar
        });
        this.total = Number(res.data.total)
        this.data = res.data.records
      }
    },
    async editorFn(val, data, type) {
      if (data != '') {
        let res = await singleDetail({
          id: data.id,
          type: 2
        })
        if (res.code == 200) {
          res.data.fileType = String(res.data.fileType)
          res.data.injectMoment = String(res.data.injectMoment)
          res.data.loaderType = String(res.data.loaderType)
          res.data.superFlag = Boolean(res.data.superFlag)
          res.data.showFlag = Boolean(res.data.showFlag)
          let arr = res.data.fitOs.split(',')
          let arr2 = res.data.executeTime.split(',')
          arr.forEach(el => { el = String[el] })
          let newArr = arr2.map(Number)
          res.data.fitOsList = arr
          res.data.executeTimeList = newArr
          this.$refs.editorCom2.form = res.data
          this.$refs.editorCom2.visible = true
          this.$refs.editorCom2.modelType = type
          this.$refs.editorCom2.type = val
        } else {
          this.$Message.error(res.msg)
        }
      } else {
        // Object.keys(this.$refs.editorCom2.form).forEach(key => {
        //   this.$refs.editorCom2.form[key] = this.form[key] || this.$refs.editorCom2.form[key]
        // })
        for (let key in this.$refs.editorCom2.form) {
          this.$refs.editorCom2.form[key] = this.form[key]
        }
        this.$refs.editorCom2.visible = true
        this.$refs.editorCom2.modelType = type
        this.$refs.editorCom2.type = val
      }
    },
    selectFn (val) {
      this.selectVal = val
      console.log(this.selectVal)
    },
    useFn(val, item) {
      this.$refs.useGroupCom.useType = val
      this.$refs.useGroupCom.visible = true
      this.$refs.useGroupCom.curData = item
      if (item && item.id) {
        this.$refs.useGroupCom.ids = [item.id]
      } else {
        this.$refs.useGroupCom.ids = []
        this.selectVal.forEach(el => {
          this.$refs.useGroupCom.ids.push(el.id)
        })
      }
    },
    switchFn(val) {
      this.$refs.swichCom.visible = true
      this.$refs.swichCom.openType = val
    },
    delFn(val) {
      console.log(val)
    },
    cancel () {
      this.$Message.info('点击了取消')
    }
  }
}
</script>
<style lang="scss" scoped>
.marginBot10{
  margin-bottom: 10px;
}
</style>
<style lang="scss" >
.contentContainer .ivu-input-group-append{
  position: absolute;
  right: 0;
  width: 33px;
  z-index: 99;
  height: 32px;
}
</style>